/**
 * Vỏ cuộn cho các trang khách nằm NGOÀI app shell (`/booking`, `/booking/me`,
 * album, chọn ảnh).
 *
 * `globals.css` khoá `html, body { overflow: hidden }` để app shell không sinh
 * thanh cuộn thứ hai của cả trang. Hệ quả: trang nào không tự chặn chiều cao
 * thì phần nội dung dài hơn màn hình bị CẮT — không cuộn tới được. `min-h-dvh`
 * KHÔNG chặn chiều cao (thẻ vẫn nở theo nội dung) nên `overflow-y-auto` đi kèm
 * không bao giờ chạy; phải là `h-full` thì mới sinh thanh cuộn.
 */
export const publicPageScrollClass = "h-full overflow-y-auto";

/** Bọc một trang khách để nó cuộn được. `className` cộng thêm nền, padding… */
export function PublicPageScroll({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return <div className={className ? `${publicPageScrollClass} ${className}` : publicPageScrollClass}>{children}</div>;
}
